import { render, staticRenderFns } from "./DocumentsPage.vue?vue&type=template&id=17be0347&scoped=true"
import script from "./DocumentsPage.vue?vue&type=script&lang=js"
export * from "./DocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPage.vue?vue&type=style&index=0&id=17be0347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be0347",
  null
  
)

export default component.exports